import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Uniform() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="School Uniform"
          title2=""
          parentTitle="About"
          path="School Uniform"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="row g-4">
            {/* Main Content */}
            <div className="col-12 ">
              <div className="contact-form-card h-100">
                <h2 className="about-title mb-4">School Uniform</h2>

                {/* Kiddy & KG */}
                <div className="uniform-section mb-4">
                  <div className="table-responsive">
                    <table className="table uniform-table align-middle mb-0">
                      <thead>
                        <tr>
                          <td>
                            <span className="day-badge">Fri</span>
                          </td>

                          <td>
                            House T-shirt, white full pants, ID card, plain
                            white socks and white keds, belt (blue and white
                            lined).
                          </td>

                          <td>
                            House T-shirt, white box pleated divided skirt, ID
                            card, plain white socks and white keds, belt (blue
                            &amp; white lined) &amp; black hair band (single
                            pleated hair).
                          </td>
                        </tr>
                        <tr>
                          <th style={{ width: "15%" }}>Days</th>
                          <th style={{ width: "42.5%" }}>
                            Kiddy & K.G I & KG II - Boys
                          </th>
                          <th style={{ width: "42.5%" }}>
                            Kiddy & K.G I & KG II - Girls
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>
                            <span className="day-badge">Mon, Tue, Thu</span>
                          </td>
                          <td>
                            Pink check shirt half sleeves
                            <br />
                            <small>(Winter: full sleeves)</small>, pink shorts,
                            ID card, tie, black shoes, yellow socks with pink &
                            white strip.
                          </td>
                          <td>
                            Pink check frock, black shoes, yellow socks with
                            pink & white strip, black hair band.
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <span className="day-badge">Wed, Fri</span>
                          </td>
                          <td>
                            White shirt with half sleeves
                            <br />
                            <small>(Winter: full sleeves)</small>, white shorts
                            <br />
                            <small>(Winter: full pants)</small>, check tie, ID
                            card, plain white keds, belt (pink with yellow
                            lining).
                          </td>
                          <td>
                            White pleated skirt, white shirt with half sleeves
                            <br />
                            <small>(Winter: full sleeves)</small>, check tie, ID
                            card, plain white keds, belt (blue & white lined),
                            black hair band (single pleated hair), white
                            leggings.
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <span className="day-badge winter">Winter</span>
                          </td>
                          <td>
                            Pink pull-over, monkey cap
                            <br />
                            <small>(only pink colour)</small>
                          </td>
                          <td>
                            Pink sweater, scarf
                            <br />
                            <small>(only pink colour)</small>, pink leggings.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Classes I-V */}
                <div className="uniform-section mb-4">
                  <div className="table-responsive">
                    <table className="table uniform-table align-middle mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: "15%" }}>Days</th>
                          <th style={{ width: "42.5%" }}>Boys - Classes I-V</th>
                          <th style={{ width: "42.5%" }}>
                            Girls - Classes I-V
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>
                            <span className="day-badge">Mon, Tue, Thu</span>
                          </td>
                          <td>
                            Check shirt, blue pants, blue check tie, ID card,
                            plain blue socks and black school shoes, belt (blue
                            & white lined).
                          </td>
                          <td>
                            Check shirt, box pleated skirt below knee length,
                            blue check tie, ID card, plain blue socks, black
                            shoes, black hair band (single pleated hair), belt
                            (blue & white lined), navy blue leggings
                            <br />
                            <small>(In winter)</small>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <span className="day-badge">Wed</span>
                          </td>
                          <td>
                            White shirt with half sleeves
                            <br />
                            <small>(Winter: full sleeves)</small>, white shorts
                            (Classes I-IV), full pants (Class V onwards), check
                            tie, ID card, plain white shoes, belt (blue & white
                            lined).
                          </td>
                          <td>
                            White box pleated skirt below knee length, white
                            shirt with half sleeves, check tie, ID card, plain
                            white socks and white shoes, belt (blue & white
                            lined), black hair band (single pleated hair), white
                            leggings.
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <span className="day-badge">Fri</span>
                          </td>
                          <td>
                            House T-shirt, white shorts (Classes I-IV), full
                            pants (Class V onwards), ID card, plain white socks
                            and white shoes, belt (blue & white lined).
                          </td>
                          <td>
                            House T-shirt, white box pleated divided skirt below
                            knee length, ID card, plain white socks and white
                            shoes, belt (blue & white lined), black hair band
                            (single pleated hair), white leggings.
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <span className="day-badge winter">Winter</span>
                          </td>
                          <td>
                            Blue pull-over, muffler
                            <br />
                            <small>(only blue colour)</small>, blue blazer
                            (Class V).
                          </td>
                          <td>
                            Blue cardigan, muffler
                            <br />
                            <small>(only blue colour)</small>, blue blazer
                            (Class V).
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Classes VI-XII */}
                <div className="uniform-section">
                  <div className="table-responsive">
                    <table className="table uniform-table align-middle mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: "15%" }}>Days</th>
                          <th style={{ width: "42.5%" }}>
                            Boys - Classes VI-XII
                          </th>
                          <th style={{ width: "42.5%" }}>
                            Girls - Classes VI-XII
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>
                            <span className="day-badge">Mon, Tue, Thu</span>
                          </td>
                          <td>
                            Navy blue full pant, blue striped white half-sleeved
                            shirt, navy blue tie, white socks, black shoes, belt
                            (white-blue lined).
                            <br />
                            <strong>Winter:</strong> Navy blue blazer, black
                            muffler.
                          </td>
                          <td>
                            Navy blue parallel pants, blue striped half-sleeved
                            white kurtis, navy blue sleeveless jacket, white
                            socks, black shoes.
                            <br />
                            <strong>Winter:</strong> Navy blue blazer, black
                            muffler.
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <span className="day-badge">Wed</span>
                          </td>
                          <td>
                            White shirt with half sleeves, white full pants,
                            check tie, ID card, plain white shoes, belt (blue &
                            white lined).
                          </td>
                          <td>
                            White coloured parallel pants, white half-sleeved
                            kurtis, navy blue sleeveless jacket, ID card, plain
                            white socks and white shoes, black hair band (single
                            pleated hair).
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <span className="day-badge">Fri</span>
                          </td>
                          <td>
                            White coloured full pants, house-coloured T-shirt,
                            white shoes, white socks.
                          </td>
                          <td>
                            White coloured parallel pants, white kurtis,
                            house-coloured check sleeveless jacket, white shoes,
                            white socks, black hair band (single pleated hair).
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Image */}
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Uniform;
